import { DSStatus } from '@cims-online/shared'
import { useAuthContext } from 'context/AuthContext'
import { Button, Tooltip } from 'antd'
import { DesignSubmittal } from '../../../../../DesignSubmittalLogContext/types'
import { useDesignSubmittalLogContext } from '../../../../../DesignSubmittalLogContext'

export const Status: React.VFC<DesignSubmittal> = (record) => {
  const { user } = useAuthContext()
  const {
    advancementModal: { toggle },
    permissions: { canRoute, canDisposition },
  } = useDesignSubmittalLogContext()
  const { statusId, dsToDSDisciplines, deleted, projectId } = record
  const canAdvance = (
    statusId: string,
    dsToDSDisciplines: DesignSubmittal['dsToDSDisciplines']
  ): boolean => {
    if (!user) return false

    if (statusId === DSStatus.RouterReview.id)
      return (
        (canRoute &&
          (!dsToDSDisciplines.length ||
            dsToDSDisciplines
              .flatMap(({ discipline: { users } }) =>
                users.map(({ id }) => id.toLowerCase())
              )
              .includes(user.id.toLowerCase()))) ||
        user.admin(projectId).authorized ||
        user.developer === true
      )
    else if (statusId === DSStatus.DisciplineAction.id)
      return (
        canDisposition &&
        !!dsToDSDisciplines.length &&
        dsToDSDisciplines.every(({ accepted }) => accepted)
      )
    else return false
  }
  return canAdvance(statusId, dsToDSDisciplines) ? (
    <Button
      type="link"
      style={{ padding: 0 }}
      disabled={deleted}
      onClick={() => toggle(record)}
    >
      {DSStatus.fromIdOrFail(statusId).name}
    </Button>
  ) : (
    <Tooltip
      title={
        canDisposition && statusId === DSStatus.DisciplineAction.id
          ? `All Disciplines must be accepted to advance to ${DSStatus.ReturnedToDesignBuilder.name}`
          : undefined
      }
    >
      {DSStatus.fromIdOrFail(statusId).name}
    </Tooltip>
  )
}
